// src/pages/RegisterPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './RegisterPage.css'; // Optional CSS

const API_URL = process.env.REACT_APP_API_URL;

const RegisterPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleRegister = (e) => {
    e.preventDefault();

    // Browser will already handle invalid password with pattern attribute,
    // so we just send request if the form is valid.
    fetch(`${API_URL}/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, password })
    })
      .then(response => {
        if (!response.ok) {
          // If the response is not OK (e.g., 400 or 401), throw an error
          throw new Error(response.status);
        }
        return response.json(); // Parse the successful response
      })
      .then(data => {
        // If registration is successful, redirect to login
        navigate('/login');
      })
      .catch(err => {
        // err.message will be the status code, e.g., '400' or '401'
        if (err.message === '401') {
          // 401 used here for "email already exists"
          setErrorMessage("This email is already in use.");
        } else if (err.message === '400') {
          // 400 used if the password or other data is invalid
          setErrorMessage(
            "Password must have at least 8 characters, one uppercase letter, one digit, and one special character."
          );
        } else {
          setErrorMessage("Registration failed. Please try again.");
        }
        console.error(err);
      });
  };

  return (
    <div className="register-page">
      <h2>Register</h2>
      <form onSubmit={handleRegister}>
        <label>Name:</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <label>Password:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          // HTML5 validation pattern:
          pattern="^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$"
          title="Password must have at least 8 characters, one uppercase letter, one digit, and one special character."
        />
        <button type="submit">Register</button>
      </form>

      {/* Conditionally render the error message from the server */}
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </div>
  );
};

export default RegisterPage;
